import { useDevice } from "@/store/useDevice";
import type { InspectionData } from "../../inspection.d";
import InspectionGeneralData from "./InspectionGeneralData";
import InspectionGeneralDataMobile from "./InspectionGeneralDataMobile";

const InpectionDetails = ({
  inspectionData,
}: {
  inspectionData: InspectionData;
}) => {
  const { isMobile } = useDevice();

  if (isMobile) {
    return <InspectionGeneralDataMobile inspectionData={inspectionData} />;
  }
  return <InspectionGeneralData inspectionData={inspectionData} />;
};

export default InpectionDetails;
